export const RoleEnumValue = {
  Administrator: '4cc9d13c-673d-49b2-bbfc-696f51bf7adf',
  Guest: 'd5c9a44a-e13a-41eb-bb0f-3f86b5d13ad8',
  User: 'd5c9a44a-e13a-41eb-bb0f-3f86b5d13ad9',
  VendorReception: 'd5c9a44a-e13a-41eb-bb0f-4g96b5d13be0',
  VendorPurchaseOrder: 'd5c9a44a-e13a-41eb-bb0f-4g97c6e24cd1',
  DealerOrderManager: 'e08c09b7-1d07-4430-a705-7e1b88ac2f63',
  MerchandisingProgram: 'f4d7a7b7-42c7-4c08-9d70-4dc88ea0d0d6',
};

export const RoleEnums = [
  {
    value: RoleEnumValue.Administrator,
    name: 'Administrator',
    labelFrench: 'Administrateur',
    labelEnglish: 'Administrator',
  },
  {
    value: RoleEnumValue.Guest,
    name: 'Guest',
    labelFrench: 'Visiteur',
    labelEnglish: 'Guest',
  },
  {
    value: RoleEnumValue.User,
    name: 'User',
    labelFrench: 'Utilisateur',
    labelEnglish: 'User',
  },
  {
    value: RoleEnumValue.VendorReception,
    name: 'VendorReception',
    labelFrench: 'Fournisseur Réception',
    labelEnglish: 'Vendor Reception',
  },
  {
    value: RoleEnumValue.VendorPurchaseOrder,
    name: 'VendorPurchaseOrder',
    labelFrench: 'Fournisseur PO',
    labelEnglish: 'Vendor PO',
  },
  {
    value: RoleEnumValue.DealerOrderManager,
    name: 'DealerOrderManager',
    labelFrench: 'Gestionnaire de commande pour concessionnaire',
    labelEnglish: 'Dealer order manager',
  },
  {
    value: RoleEnumValue.MerchandisingProgram,
    name: 'MerchandisingProgram',
    labelFrench: 'Programme de marchandisage',
    labelEnglish: 'Merchandising Program',
  },
];
